module.exports = __webpack_public_path__ + "img/CANAM4.e951fe2b.png";